type TMultichoiceDefaultStyles = {
  panelBackground: string;
  panelBorderRadius: number;
  optionTextColor: string;
  checkboxColor: string;
  mediaPanelWidth: number;
  mediaPanelHeight: number;
  hasSetWidthHeight: boolean;
  includeRadioCheckbox: boolean;
  dropShadow: boolean;
};

export const multichoiceDefaultStyles: {
  [key: string]: TMultichoiceDefaultStyles;
} = {
  base: {
    panelBackground: '#1A1A2B',
    panelBorderRadius: 5,
    optionTextColor: '#fff',
    checkboxColor: '#fff',
    mediaPanelWidth: 320,
    mediaPanelHeight: 360,
    dropShadow: false,
    hasSetWidthHeight: false,
    includeRadioCheckbox: true,
  },
};

export const getDefaultStyles = (version = 'base') => {
  // throw. or return empty object with warning ???
  return (multichoiceDefaultStyles[version] || {}) as TMultichoiceDefaultStyles;
};
